import { createContext, useContext } from 'react';
export const FormValuesContext = /*#__PURE__*/ createContext(undefined);
export function useFormValues() {
    const context = useContext(FormValuesContext);
    if (context === undefined) {
        throw new Error('useFormValues must be used within a FormValuesProvider');
    }
    return context;
}

//# sourceMappingURL=form-values-context.js.map